module.exports = require('./helpers/bundle-url').getBundleURL('2ws0Z') + "logo-dark.ba5147f0.svg";